import { SectionTitle } from "@/components/common/SectionTitle";
import topupIcon from "@/assets/icons/topup_history.svg";
import { TopupHistoryList } from "@/features/topup-history/TopupHistoryList";

export default function TopupHistoryPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 pt-4 pb-16 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between">
        <SectionTitle img={topupIcon} title="Top-Up History" />
      </div>

      <TopupHistoryList />
    </div>
  );
}